import React, { Component } from "react";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import { FiFile, FiCheck, FiX } from "react-icons/fi";
import "../../Shared/Forms/form.css";

class AdminDataBoardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalContents: 0,
      totalApproved: 0,
      totalDeclined: 0
    };
  }

  render() {
    const {
      totalApproved,
      totalDeclined,
      total,
      postFrequency,
      postCycle
    } = this.props;

    return (
      <div>
        <Card>
          <CardHeader>
            Summary - {postFrequency} uploads {postCycle}
          </CardHeader>

          <CardBody>
            <Row>
              <Col sm="4">
                <div className="dashboard-box verticalLine1">
                  <div className="circle blue">
                    <FiFile size={40} color={"white"} />
                  </div>
                  <div>
                    <span> Total Contents </span>
                    <h4 style={{ fontWeight: "bold" }}>{total} </h4>
                  </div>
                </div>
              </Col>

              <Col sm="4">
                <div className="dashboard-box verticalLine2">
                  <div className="circle green">
                    <FiCheck size={40} color={"white"} />
                  </div>
                  <div>
                    <span> Total Approved </span>
                    <h4 style={{ fontWeight: "bold" }}>{totalApproved}</h4>
                  </div>
                </div>
              </Col>

              <Col sm="4">
                <div className="dashboard-box verticalLine3">
                  <div className="circle wine">
                    <FiX size={40} color={"white"} />
                  </div>
                  <div>
                    <span> Total Declined </span>
                    <h4 style={{ fontWeight: "bold" }}>{totalDeclined}</h4>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}
export default AdminDataBoardForm;
